import Vue from 'vue'
import axios from './router/axios'
import VueAxios from 'vue-axios'
import App from './App'

import './permission' // 权限
import './errorLog' // 错误日志
import router from './router/router'
import store from './store'
import SvgIcon from '@/components/SvgIcon'// svg组件
// 引入avue的包
import '@topconn/avue/lib/index.js'
import VueClipboard from 'vue-clipboard2'


// import the component
import Treeselect from '@riophae/vue-treeselect'
import {
  loadStyle
} from './util/util'

import {
  iconfontUrl,
  iconfontVersion
} from '@/config/env'
import * as filters from './filters' // 全局filter
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import './styles/common.scss'
// 引入avue的样式文件
import '@topconn/avue/lib/theme-chalk/index.css'
import  VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//引入 easytable
import 'vue-easytable/libs/themes-base/index.css'
import {VTable, VPagination} from 'vue-easytable'

/**
 * 图片信息处理
 */
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import './styles/font.css'

Vue.use(preview)

Vue.use(VueQuillEditor)

Vue.config.productionTip = false

Vue.use(VueClipboard)

Vue.use(VueAxios, axios)

Vue.component('Treeselect', Treeselect)
// register globally
Vue.component('svg-icon', SvgIcon)
//easytable
Vue.component(VTable.name, VTable)
Vue.component(VPagination.name, VPagination)
Vue.directive('noMoreClick', {
  inserted(el, binding) {
    el.addEventListener('click', e => {
      el.classList.add('is-disabled');
      el.disabled = true;
      setTimeout(() => {
        el.disabled = false;
        el.classList.remove('is-disabled');
      }, 3000)
    })
  }
});
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// iconfontVersion.forEach(ele => {
//   loadStyle(iconfontUrl.replace('$key', ele))
// })

/**
 * 音频信息处理
 */
import audio from 'vue-mobile-audio'
Vue.use(audio)



const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('@/icons/svg', false, /\.svg$/)
requireAll(req)




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
